<template>
  <v-container>
    <div class="grey--text text--darken-1 text-h5 text-sm-h4 text-md-h3 text-l-h2 text-xl-h2 mt-2 mb-2">
      Pricing
    </div>

    <v-row flex>
      <v-col xl="6" lg="8" md="10" sm="12" cols="12">
        <v-card outlined>
          <v-card-text>  
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th></th>
                    <th v-for="(price, index) in prices.items" :key="index" class="text-center text-h5">  
                      {{ price.name }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(feature,i) in prices.features" :key="i">
                    <td class="text-left px-0">
                      <v-icon left color="grey lighten-2" class="d-none d-sm-inline-flex">{{ feature.icon }}</v-icon>
                      {{ feature.name }}
                    </td>
                    <td v-for="(priceFeature, j) in prices.items.map(item => item.features[i])"
                        class="text-center"
                        :key="j"
                        >
                        <span v-if="typeof priceFeature === 'boolean'" >
                          <v-icon v-if="priceFeature === true" color="success">check</v-icon>
                          <v-icon v-else color="error">close</v-icon>
                        </span>
                        <span v-else v-html="priceFeature"></span>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td v-for="(price, index) in prices.items" :key="index" class="text-center py-3">
                      
                      <v-btn v-if="price.action.signup" depressed color="primary" router :to="{ name: 'Login', params: { userType: 'lecturer' } }" :disabled="user.loggedIn">
                        Sign up
                      </v-btn>

                      <v-btn v-if="price.action.contactUs" depressed color="primary" router :to="{ name: 'Contact' }">
                        Contact Us
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      prices: {
        features: [
          { name: "View student progress during tutorials", icon: 'visibility' },
          { name: "Prompt those who should be asking for help", icon: 'announcement' },
          { name: "Respond to those who do ask for help", icon: 'hearing' },
          { name: "Assist them via screenshare", icon: 'screen_share' },
          { name: "Training", icon: 'build' },
          { name: "Request new features", icon: 'request_page' },
          { name: "Support", icon: 'support_agent' },
          { name: "Price", icon: 'attach_money' },
        ], 
        items: [
          {
            name: 'Trial',
            features: [
              true,
              true,
              true,
              true,
              false,
              false,
              "Email (within 72h)",
              "Free until 2021"
            ],
            action: {
              signup: true
            }
          },
          {
            name: 'University',
            features: [
              true,
              true,
              true,
              true,
              true,
              true,
              "Email (same day)",
              "Annual licence fee"
            ],
            action: {
              contactUs: true
            }
          }
        ]
      }     
    }
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  }
}
</script>

<style scoped>
</style>